{
  "HELP_CENTER": {
    "TITLE": "Centrum pomoci",
    "NEW_PAGE": {
      "DESCRIPTION": "Vytvorte samoobslužné portály centra pomoci pre svojich zákazníkov. Pomôžte im rýchlo nájsť odpovede bez čakania. Zefektívnite dopyty, zvýšte efektivitu agentov a pozdvihnite zákaznícku podporu.",
      "CREATE_PORTAL_BUTTON": "Vytvoriť portál"
    },
    "NEW_ARTICLE_PAGE": {
      "PLACEHOLDER_TITLE": "Bez názvu"
    },
    "HEADER": {
      "FILTER": "Filtrovať podľa",
      "SORT": "Zoradiť podľa",
      "LOCALE": "Jazyk",
      "SETTINGS_BUTTON": "Nastavenia",
      "NEW_BUTTON": "Nový článok",
      "DROPDOWN_OPTIONS": {
        "PUBLISHED": "Publikované",
        "DRAFT": "Koncept",
        "ARCHIVED": "Archivované"
      },
      "TITLES": {
        "ALL_ARTICLES": "Všetky články",
        "MINE": "Moje články",
        "DRAFT": "Články v stave Draft",
        "ARCHIVED": "Archivované články"
      },
      "LOCALE_SELECT": {
        "TITLE": "Vybrať jazyk",
        "PLACEHOLDER": "Vybrať jazyk",
        "NO_RESULT": "Nenašiel sa žiadny jazyk",
        "SEARCH_PLACEHOLDER": "Hľadať jazyk"
      }
    },
    "EDIT_HEADER": {
      "ALL_ARTICLES": "Všetky články",
      "PUBLISH_BUTTON": "Publikovať",
      "MOVE_TO_ARCHIVE_BUTTON": "Presunúť do archívu",
      "PREVIEW": "Náhľad",
      "ADD_TRANSLATION": "Pridať preklad",
      "OPEN_SIDEBAR": "Otvoriť bočný panel",
      "CLOSE_SIDEBAR": "Zatvoriť bočný panel",
      "SAVING": "Ukladanie...",
      "SAVED": "Uložené"
    },
    "ARTICLE_EDITOR": {
      "IMAGE_UPLOAD": {
        "TITLE": "Nahrať obrázok",
        "UPLOADING": "Nahrávanie...",
        "SUCCESS": "Obrázok bol úspešne nahraný",
        "ERROR": "Chyba pri nahrávaní obrázka",
        "UN_AUTHORIZED_ERROR": "Nemáte oprávnenie na nahrávanie obrázkov",
        "ERROR_FILE_SIZE": "Veľkosť obrázka by mala byť menšia ako {size}MB",
        "ERROR_FILE_FORMAT": "Formát obrázka by mal byť jpg, jpeg alebo png",
        "ERROR_FILE_DIMENSIONS": "Rozmery obrázka by mali byť menšie ako 2000 x 2000"
      },
      "ANCHOR": {
        "BUTTON": "Vložiť kotvu",
        "TITLE": "Vložiť kotvu",
        "SUBMIT": "Vložiť",
        "PLACEHOLDER": "nazov-kotvy"
      }
    },
    "ARTICLE_SETTINGS": {
      "TITLE": "Nastavenia článkov",
      "FORM": {
        "CATEGORY": {
          "LABEL": "Kategória",
          "TITLE": "Vyberte kategóriu",
          "PLACEHOLDER": "Vyberte kategóriu",
          "NO_RESULT": "Nenašla sa žiadna kategória",
          "SEARCH_PLACEHOLDER": "Hľadať kategóriu"
        },
        "AUTHOR": {
          "LABEL": "Autor",
          "TITLE": "Vyberte autora",
          "PLACEHOLDER": "Vyberte autora",
          "NO_RESULT": "Nenašli sa žiadni autori",
          "SEARCH_PLACEHOLDER": "Hľadať autora"
        },
        "META_TITLE": {
          "LABEL": "Meta názov",
          "PLACEHOLDER": "Pridať meta názov"
        },
        "META_DESCRIPTION": {
          "LABEL": "Meta popis",
          "PLACEHOLDER": "Pridajte svoj meta popis pre lepšie výsledky SEO..."
        },
        "META_TAGS": {
          "LABEL": "Meta značky",
          "PLACEHOLDER": "Pridajte meta značky oddelené čiarkou..."
        }
      },
      "BUTTONS": {
        "ARCHIVE": "Archivovať článok",
        "DELETE": "Odstrániť článok"
      }
    },
    "ARTICLE_SEARCH_RESULT": {
      "UNCATEGORIZED": "Bez kategórie",
      "SEARCH_RESULTS": "Výsledky vyhľadávania pre {query}",
      "EMPTY_TEXT": "Vyhľadajte články, ktoré chcete vložiť do odpovedí.",
      "SEARCH_LOADER": "Vyhľadávanie...",
      "INSERT_ARTICLE": "Vložiť",
      "NO_RESULT": "Nenašli sa žiadne články",
      "COPY_LINK": "Skopírovať odkaz na článok do schránky",
      "OPEN_LINK": "Otvoriť článok na novej karte",
      "PREVIEW_LINK": "Náhľad článku"
    },
    "PORTAL": {
      "HEADER": "Portály",
      "DEFAULT": "Predvolený",
      "NEW_BUTTON": "Nový portál",
      "ACTIVE_BADGE": "aktívny",
      "CHOOSE_LOCALE_LABEL": "Vyberte jazyk",
      "LOADING_MESSAGE": "Načítavanie portálov...",
      "ARTICLES_LABEL": "články",
      "NO_PORTALS_MESSAGE": "Nie sú dostupné žiadne portály",
      "ADD_NEW_LOCALE": "Pridať nový jazyk",
      "POPOVER": {
        "TITLE": "Portály",
        "PORTAL_SETTINGS": "Nastavenia portálu",
        "SUBTITLE": "Máte viacero portálov a pre každý portál môžete mať rôzne jazyky.",
        "CANCEL_BUTTON_LABEL": "Zrušiť",
        "CHOOSE_LOCALE_BUTTON": "Vybrať jazyk"
      },
      "PORTAL_SETTINGS": {
        "LIST_ITEM": {
          "HEADER": {
            "COUNT_LABEL": "články",
            "ADD": "Pridať jazyk",
            "VISIT": "Navštíviť stránku",
            "SETTINGS": "Nastavenia",
            "DELETE": "Vymazať"
          },
          "PORTAL_CONFIG": {
            "TITLE": "Konfigurácia portálu",
            "ITEMS": {
              "NAME": "Názov",
              "DOMAIN": "Vlastná doména",
              "SLUG": "Slug",
              "TITLE": "Názov portálu",
              "THEME": "Farba motívu",
              "SUB_TEXT": "Vedľajší text portálu"
            }
          },
          "AVAILABLE_LOCALES": {
            "TITLE": "Dostupné jazyky",
            "TABLE": {
              "NAME": "Názov jazyka",
              "CODE": "Kód jazyka",
              "ARTICLE_COUNT": "Počet článkov",
              "CATEGORIES": "Počet kategórií",
              "SWAP": "Zameniť",
              "DELETE": "Vymazať",
              "DEFAULT_LOCALE": "Predvolený"
            }
          }
        },
        "DELETE_PORTAL": {
          "TITLE": "Vymazať portál",
          "MESSAGE": "Naozaj chcete vymazať tento portál",
          "YES": "Áno, vymazať portál",
          "NO": "Nie, ponechať portál",
          "API": {
            "DELETE_SUCCESS": "Portál bol úspešne vymazaný",
            "DELETE_ERROR": "Chyba pri mazaní portálu"
          }
        }
      },
      "EDIT": {
        "HEADER_TEXT": "Upraviť portál",
        "TABS": {
          "BASIC_SETTINGS": {
            "TITLE": "Základné informácie"
          },
          "CUSTOMIZATION_SETTINGS": {
            "TITLE": "Prispôsobenie portálu"
          },
          "CATEGORY_SETTINGS": {
            "TITLE": "Kategórie"
          },
          "LOCALE_SETTINGS": {
            "TITLE": "Jazyky"
          }
        },
        "CATEGORIES": {
          "TITLE": "Kategórie v",
          "NEW_CATEGORY": "Nová kategória",
          "TABLE": {
            "NAME": "Názov",
            "DESCRIPTION": "Popis",
            "LOCALE": "Jazyk",
            "ARTICLE_COUNT": "Počet článkov",
            "ACTION_BUTTON": {
              "EDIT": "Upraviť kategóriu",
              "DELETE": "Vymazať kategóriu"
            },
            "EMPTY_TEXT": "Nenašli sa žiadne kategórie"
          }
        },
        "EDIT_BASIC_INFO": {
          "BUTTON_TEXT": "Aktualizovať základné nastavenia"
        }
      },
      "ADD": {
        "CREATE_FLOW": {
          "BASIC": {
            "TITLE": "Informácie o centre pomoci",
            "BODY": "Základné informácie o portáli"
          },
          "CUSTOMIZATION": {
            "TITLE": "Prispôsobenie centra pomoci",
            "BODY": "Prispôsobiť portál"
          },
          "FINISH": {
            "TITLE": "Voilá! 🎉",
            "BODY": "Všetko je pripravené!"
          }
        },
        "CREATE_FLOW_PAGE": {
          "BACK_BUTTON": "Späť",
          "BASIC_SETTINGS_PAGE": {
            "HEADER": "Vytvoriť portál",
            "TITLE": "Informácie o centre pomoci",
            "CREATE_BASIC_SETTING_BUTTON": "Vytvoriť základné nastavenia portálu"
          },
          "CUSTOMIZATION_PAGE": {
            "HEADER": "Prispôsobenie portálu",
            "TITLE": "Prispôsobenie centra pomoci",
            "UPDATE_PORTAL_BUTTON": "Aktualizovať nastavenia portálu"
          },
          "FINISH_PAGE": {
            "TITLE": "Voilá!🎉 Všetko je nastavené!",
            "MESSAGE": "Teraz môžete vidieť tento vytvorený portál na stránke všetkých portálov.",
            "FINISH": "Prejsť na stránku všetkých portálov"
          }
        },
        "LOGO": {
          "LABEL": "Logo",
          "UPLOAD_BUTTON": "Nahrať logo",
          "HELP_TEXT": "Toto logo sa zobrazí v hlavičke portálu.",
          "IMAGE_UPLOAD_SUCCESS": "Logo bolo úspešne nahrané",
          "IMAGE_UPLOAD_ERROR": "Chyba pri nahrávaní loga",
          "IMAGE_DELETE_ERROR": "Chyba pri mazaní loga"
        },
        "NAME": {
          "LABEL": "Názov",
          "PLACEHOLDER": "Názov portálu",
          "HELP_TEXT": "Názov sa použije v internom verejne prístupnom portáli.",
          "ERROR": "Názov je povinný"
        },
        "SLUG": {
          "LABEL": "Slug",
          "PLACEHOLDER": "Slug portálu pre URL adresy",
          "ERROR": "Slug je povinný"
        },
        "DOMAIN": {
          "LABEL": "Vlastná doména",
          "PLACEHOLDER": "Vlastná doména portálu",
          "HELP_TEXT": "Pridajte len ak chcete používať vlastnú doménu pre svoje portály. Napr.: {exampleURL}",
          "ERROR": "Zadajte platnú URL domény"
        },
        "HOME_PAGE_LINK": {
          "LABEL": "Odkaz na domovskú stránku",
          "PLACEHOLDER": "Odkaz na domovskú stránku portálu",
          "HELP_TEXT": "Odkaz použitý na návrat z portálu na domovskú stránku. Napr.: {exampleURL}",
          "ERROR": "Zadajte platnú URL domovskej stránky"
        },
        "THEME_COLOR": {
          "LABEL": "Farba motívu portálu",
          "HELP_TEXT": "Táto farba sa zobrazí ako farba motívu portálu."
        },
        "PAGE_TITLE": {
          "LABEL": "Názov stránky",
          "PLACEHOLDER": "Názov stránky portálu",
          "HELP_TEXT": "Názov stránky sa použije vo verejne prístupnom portáli.",
          "ERROR": "Názov stránky je povinný"
        },
        "HEADER_TEXT": {
          "LABEL": "Text hlavičky",
          "PLACEHOLDER": "Text hlavičky portálu",
          "HELP_TEXT": "Text hlavičky portálu sa použije vo verejne prístupnom portáli.",
          "ERROR": "Text hlavičky portálu je povinný"
        },
        "API": {
          "SUCCESS_MESSAGE_FOR_BASIC": "Portál bol úspešne vytvorený.",
          "ERROR_MESSAGE_FOR_BASIC": "Nepodarilo sa vytvoriť portál. Skúste to znova.",
          "SUCCESS_MESSAGE_FOR_UPDATE": "Portál bol úspešne aktualizovaný.",
          "ERROR_MESSAGE_FOR_UPDATE": "Nepodarilo sa aktualizovať portál. Skúste to znova."
        }
      },
      "ADD_LOCALE": {
        "TITLE": "Pridať nový jazyk",
        "SUB_TITLE": "Týmto pridáte nový jazyk do vášho zoznamu dostupných prekladov.",
        "PORTAL": "Portál",
        "LOCALE": {
          "LABEL": "Jazyk",
          "PLACEHOLDER": "Vyberte jazyk",
          "ERROR": "Jazyk je povinný"
        },
        "BUTTONS": {
          "CREATE": "Vytvoriť jazyk",
          "CANCEL": "Zrušiť"
        },
        "API": {
          "SUCCESS_MESSAGE": "Jazyk bol úspešne pridaný",
          "ERROR_MESSAGE": "Nepodarilo sa pridať jazyk. Skúste to znova."
        }
      },
      "CHANGE_DEFAULT_LOCALE": {
        "API": {
          "SUCCESS_MESSAGE": "Predvolený jazyk bol úspešne aktualizovaný",
          "ERROR_MESSAGE": "Nepodarilo sa aktualizovať predvolený jazyk. Skúste to znova."
        }
      },
      "DELETE_LOCALE": {
        "API": {
          "SUCCESS_MESSAGE": "Jazyk bol úspešne odstránený z portálu",
          "ERROR_MESSAGE": "Nepodarilo sa odstrániť jazyk z portálu. Skúste to znova."
        }
      }
    },
    "TABLE": {
      "404": "Žiadne články nezodpovedajú vášmu hľadaniu 🔍",
      "LOADING_MESSAGE": "Načítavanie článkov...",
      "NO_ARTICLES": "Nie sú dostupné žiadne články",
      "HEADERS": {
        "TITLE": "Názov",
        "CATEGORY": "Kategória",
        "READ_COUNT": "Zobrazenia",
        "STATUS": "Stav",
        "LAST_EDITED": "Naposledy upravené"
      },
      "COLUMNS": {
        "BY": "od",
        "AUTHOR_NOT_AVAILABLE": "Autor nie je k dispozícii"
      }
    },
    "EDIT_ARTICLE": {
      "LOADING": "Načítavanie článku...",
      "TITLE_PLACEHOLDER": "Názov článku sem",
      "CONTENT_PLACEHOLDER": "Napíšte svoj článok sem",
      "API": {
        "ERROR": "Chyba pri ukladaní článku"
      }
    },
    "PUBLISH_ARTICLE": {
      "API": {
        "ERROR": "Chyba pri publikovaní článku",
        "SUCCESS": "Článok bol úspešne publikovaný"
      }
    },
    "ARCHIVE_ARTICLE": {
      "API": {
        "ERROR": "Chyba pri archivácii článku",
        "SUCCESS": "Článok bol úspešne archivovaný"
      }
    },
    "DRAFT_ARTICLE": {
      "API": {
        "ERROR": "Chyba pri vytváraní Draftu článku",
        "SUCCESS": "Draft článku bol úspešne vytvorený"
      }
    },
    "DELETE_ARTICLE": {
      "MODAL": {
        "CONFIRM": {
          "TITLE": "Potvrdiť odstránenie",
          "MESSAGE": "Naozaj chcete odstrániť tento článok?",
          "YES": "Áno, odstrániť",
          "NO": "Nie, ponechať"
        }
      },
      "API": {
        "SUCCESS_MESSAGE": "Článok bol úspešne odstránený",
        "ERROR_MESSAGE": "Chyba pri mazaní článku"
      }
    },
    "CREATE_ARTICLE": {
      "ERROR_MESSAGE": "Pridajte prosím nadpis a obsah článku, až potom môžete aktualizovať nastavenia"
    },
    "SIDEBAR": {
      "SEARCH": {
        "PLACEHOLDER": "Hľadať články"
      }
    },
    "CATEGORY": {
      "ADD": {
        "TITLE": "Vytvoriť kategóriu",
        "SUB_TITLE": "Kategória sa použije vo verejne prístupnom portáli na kategorizáciu článkov.",
        "PORTAL": "Portál",
        "LOCALE": "Jazyk",
        "NAME": {
          "LABEL": "Názov",
          "PLACEHOLDER": "Názov kategórie",
          "HELP_TEXT": "Názov kategórie a ikona sa použijú vo verejne prístupnom portáli na kategorizáciu článkov.",
          "ERROR": "Názov je povinný"
        },
        "SLUG": {
          "LABEL": "Slug",
          "PLACEHOLDER": "Slug kategórie pre URL",
          "HELP_TEXT": "chat.jarabot.com/hc/my-portal/en-US/categories/my-slug",
          "ERROR": "Slug je povinný"
        },
        "DESCRIPTION": {
          "LABEL": "Popis",
          "PLACEHOLDER": "Zadajte krátky popis kategórie.",
          "ERROR": "Popis je povinný"
        },
        "BUTTONS": {
          "CREATE": "Vytvoriť kategóriu",
          "CANCEL": "Zrušiť"
        },
        "API": {
          "SUCCESS_MESSAGE": "Kategória bola úspešne vytvorená",
          "ERROR_MESSAGE": "Nepodarilo sa vytvoriť kategóriu"
        }
      },
      "EDIT": {
        "TITLE": "Upraviť kategóriu",
        "SUB_TITLE": "Úprava kategórie aktualizuje kategóriu vo verejne prístupnom portáli.",
        "PORTAL": "Portál",
        "LOCALE": "Jazyk",
        "NAME": {
          "LABEL": "Názov",
          "PLACEHOLDER": "Názov kategórie",
          "HELP_TEXT": "Názov kategórie a ikona sa použijú vo verejne prístupnom portáli na kategorizáciu článkov.",
          "ERROR": "Názov je povinný"
        },
        "SLUG": {
          "LABEL": "Slug",
          "PLACEHOLDER": "Slug kategórie pre URL",
          "HELP_TEXT": "chat.jarabot.com/hc/my-portal/en-US/categories/my-slug",
          "ERROR": "Slug je povinný"
        },
        "DESCRIPTION": {
          "LABEL": "Popis",
          "PLACEHOLDER": "Zadajte krátky popis kategórie.",
          "ERROR": "Popis je povinný"
        },
        "BUTTONS": {
          "CREATE": "Aktualizovať kategóriu",
          "CANCEL": "Zrušiť"
        },
        "API": {
          "SUCCESS_MESSAGE": "Kategória bola úspešne aktualizovaná",
          "ERROR_MESSAGE": "Nepodarilo sa aktualizovať kategóriu"
        }
      },
      "DELETE": {
        "API": {
          "SUCCESS_MESSAGE": "Kategória bola úspešne vymazaná",
          "ERROR_MESSAGE": "Nepodarilo sa vymazať kategóriu"
        }
      }
    },
    "ARTICLE_SEARCH": {
      "TITLE": "Hľadať články",
      "PLACEHOLDER": "Hľadať články",
      "NO_RESULT": "Nenašli sa žiadne články",
      "SEARCHING": "Vyhľadávanie...",
      "SEARCH_BUTTON": "Hľadať",
      "INSERT_ARTICLE": "Vložiť odkaz",
      "IFRAME_ERROR": "URL je prázdna alebo neplatná. Nie je možné zobraziť obsah.",
      "OPEN_ARTICLE_SEARCH": "Vložiť článok z centra pomoci",
      "SUCCESS_ARTICLE_INSERTED": "Článok bol úspešne vložený",
      "PREVIEW_LINK": "Náhľad článku",
      "CANCEL": "Zavrieť",
      "BACK": "Späť",
      "BACK_RESULTS": "Späť na výsledky"
    },
    "UPGRADE_PAGE": {
      "TITLE": "Centrum pomoci",
      "DESCRIPTION": "Vytvorte používateľsky prívetivé samoobslužné portály. Pomáhajte svojim používateľom pristupovať k článkom a získavať podporu 24/7. Inovujte svoje predplatné, aby ste povolili túto funkciu.",
      "SELF_HOSTED_DESCRIPTION": "Vytvorte používateľsky prívetivé samoobslužné portály. Pomáhajte svojim používateľom pristupovať k článkom a získavať podporu 24/7. Kontaktujte prosím svojho administrátora o povolení tejto funkcie.",
      "BUTTON": {
        "LEARN_MORE": "Zistiť viac",
        "UPGRADE": "Inovovať"
      },
      "FEATURES": {
        "PORTALS": {
          "TITLE": "Viac portálov",
          "DESCRIPTION": "Vytvorte viac portálov centra pomoci pre rôzne produkty pomocou rovnakého účtu."
        },
        "LOCALES": {
          "TITLE": "Plná podpora jazykov",
          "DESCRIPTION": "Lokalizujte portál vo vašom jazyku. Podporujeme všetky jazyky a umožňujeme preklady pre každý článok."
        },
        "SEO": {
          "TITLE": "Dizajn prívetivý k SEO",
          "DESCRIPTION": "Prispôsobte svoje meta značky na zlepšenie viditeľnosti vo vyhľadávačoch pomocou našich stránok prívetivých k SEO."
        },
        "API": {
          "TITLE": "Plná podpora API",
          "DESCRIPTION": "Použite portál ako bezhlavý CMS s frontendovými frameworkmi tretích strán pomocou našich API."
        }
      }
    },
    "LOADING": "Načítavanie...",
    "ARTICLES_PAGE": {
      "ARTICLE_CARD": {
        "CARD": {
          "VIEWS": "{count} zobrazení",
          "DROPDOWN_MENU": {
            "PUBLISH": "Publikovať",
            "DRAFT": "Koncept",
            "ARCHIVE": "Archivovať",
            "DELETE": "Vymazať"
          },
          "STATUS": {
            "DRAFT": "Koncept",
            "PUBLISHED": "Publikované",
            "ARCHIVED": "Archivované"
          },
          "CATEGORY": {
            "UNCATEGORISED": "Bez kategórie"
          }
        }
      },
      "ARTICLES_HEADER": {
        "TABS": {
          "ALL": "Všetky články",
          "MINE": "Moje",
          "DRAFT": "Koncept",
          "PUBLISHED": "Publikované",
          "ARCHIVED": "Archivované"
        },
        "CATEGORY": {
          "ALL": "Všetky kategórie"
        },
        "LOCALE": {
          "ALL": "Všetky jazyky"
        },
        "NEW_ARTICLE": "Nový článok"
      },
      "EMPTY_STATE": {
        "ALL": {
          "TITLE": "Napísať článok",
          "SUBTITLE": "Napíšte bohatý článok, začnime!",
          "BUTTON_LABEL": "Nový článok"
        },
        "MINE": {
          "TITLE": "Zatiaľ ste tu nenapísali žiadne články",
          "SUBTITLE": "Všetky články, ktoré ste napísali, sa tu zobrazia pre rýchly prístup."
        },
        "DRAFT": {
          "TITLE": "V stave Draft nie sú žiadne články",
          "SUBTITLE": "Články v stave Draft sa zobrazia tu"
        },
        "PUBLISHED": {
          "TITLE": "Nie sú tu žiadne publikované články",
          "SUBTITLE": "Publikované články sa zobrazia tu"
        },
        "ARCHIVED": {
          "TITLE": "V archíve nie sú žiadne články",
          "SUBTITLE": "Archivované články sa na portáli nezobrazujú, môžete ich použiť na označenie zastaraných alebo neaktuálnych stránok"
        },
        "CATEGORY": {
          "TITLE": "V tejto kategórii nie sú žiadne články",
          "SUBTITLE": "Články v tejto kategórii sa zobrazia tu"
        }
      }
    },
    "CATEGORY_PAGE": {
      "CATEGORY_HEADER": {
        "NEW_CATEGORY": "Nová kategória",
        "EDIT_CATEGORY": "Upraviť kategóriu",
        "CATEGORIES_COUNT": "{n} kategórií",
        "BREADCRUMB": {
          "CATEGORY_LOCALE": "Kategórie ({localeCode})",
          "ACTIVE_CATEGORY": "{categoryName} ({categoryCount} článkov)"
        }
      },
      "CATEGORY_EMPTY_STATE": {
        "TITLE": "Nenašli sa žiadne kategórie",
        "SUBTITLE": "Kategórie sa zobrazia tu. Kategóriu môžete pridať kliknutím na tlačidlo 'Nová kategória'."
      },
      "CATEGORY_CARD": {
        "ARTICLES_COUNT": "{count} článkov",
        "EXPAND": "Zobraziť podkategórie",
        "COLLAPSE": "Skryť podkategórie",
        "MENU": {
          "NEW_ARTICLE": "Nový článok",
          "ADD_SUBCATEGORY": "Pridať podkategóriu",
          "EDIT": "Upraviť",
          "DELETE": "Vymazať"
        }
      },
      "CATEGORY_DIALOG": {
        "CREATE": {
          "API": {
            "SUCCESS_MESSAGE": "Kategória bola úspešne vytvorená",
            "ERROR_MESSAGE": "Nepodarilo sa vytvoriť kategóriu"
          }
        },
        "EDIT": {
          "API": {
            "SUCCESS_MESSAGE": "Kategória bola úspešne aktualizovaná",
            "ERROR_MESSAGE": "Nepodarilo sa aktualizovať kategóriu"
          }
        },
        "DELETE": {
          "API": {
            "SUCCESS_MESSAGE": "Kategória bola úspešne vymazaná",
            "ERROR_MESSAGE": "Nepodarilo sa vymazať kategóriu"
          },
          "CONFIRM": {
            "TITLE": "Vymazať kategóriu",
            "DESCRIPTION": "Naozaj chcete vymazať túto kategóriu? Jej články zostanú bez kategórie.",
            "DESCRIPTION_WITH_CHILDREN": "Naozaj chcete vymazať túto kategóriu? Jej články zostanú bez kategórie a jej {count} podkategórie budú presunuté na najvyššiu úroveň.",
            "CONFIRM": "Vymazať"
          }
        },
        "HEADER": {
          "CREATE": "Vytvoriť kategóriu",
          "EDIT": "Upraviť kategóriu",
          "DESCRIPTION": "Úprava kategórie aktualizuje kategóriu vo verejne prístupnom portáli.",
          "PORTAL": "Portál",
          "LOCALE": "Jazyk"
        },
        "FORM": {
          "NAME": {
            "LABEL": "Názov",
            "PLACEHOLDER": "Názov kategórie",
            "ERROR": "Názov je povinný"
          },
          "SLUG": {
            "LABEL": "Slug",
            "PLACEHOLDER": "Slug kategórie pre URL",
            "ERROR": "Slug je povinný",
            "HELP_TEXT": "chat.jarabot.com/hc/{portalSlug}/{localeCode}/categories/{categorySlug}"
          },
          "DESCRIPTION": {
            "LABEL": "Popis",
            "PLACEHOLDER": "Zadajte krátky popis kategórie.",
            "ERROR": "Popis je povinný"
          },
          "PARENT_CATEGORY": {
            "LABEL": "Nadradená kategória",
            "PLACEHOLDER": "Vyberte nadradenú kategóriu",
            "NONE": "Žiadna (najvyššia úroveň)"
          }
        },
        "BUTTONS": {
          "CREATE": "Vytvoriť",
          "EDIT": "Aktualizovať",
          "CANCEL": "Zrušiť"
        }
      }
    },
    "LOCALES_PAGE": {
      "LOCALES_COUNT": "{n} jazykov",
      "NEW_LOCALE_BUTTON_TEXT": "Nový jazyk",
      "LOCALE_CARD": {
        "ARTICLES_COUNT": "{count} článkov",
        "CATEGORIES_COUNT": "{count} kategórií",
        "DEFAULT": "Predvolený",
        "DROPDOWN_MENU": {
          "MAKE_DEFAULT": "Nastaviť ako predvolený",
          "DELETE": "Vymazať"
        }
      },
      "ADD_LOCALE_DIALOG": {
        "TITLE": "Pridať nový jazyk",
        "DESCRIPTION": "Vyberte jazyk, v ktorom bude tento článok napísaný. Ten bude pridaný do vášho zoznamu prekladov a neskôr môžete pridať ďalšie.",
        "COMBOBOX": {
          "PLACEHOLDER": "Vybrať jazyk..."
        },
        "API": {
          "SUCCESS_MESSAGE": "Jazyk bol úspešne pridaný",
          "ERROR_MESSAGE": "Nepodarilo sa pridať jazyk. Skúste to znova."
        }
      }
    },
    "EDIT_ARTICLE_PAGE": {
      "HEADER": {
        "STATUS": {
          "SAVING": "Ukladanie...",
          "SAVED": "Uložené"
        },
        "PREVIEW": "Náhľad",
        "PUBLISH": "Publikovať",
        "DRAFT": "Koncept",
        "ARCHIVE": "Archivovať",
        "BACK_TO_ARTICLES": "Späť na články"
      },
      "DRAFT": {
        "PENDING_LABEL": "Nepublikované zmeny",
        "PROMOTE": "Publikovať zmeny",
        "DISCARD": "Zahodiť zmeny",
        "PROMOTE_SUCCESS": "Zmeny boli publikované do živého článku",
        "PROMOTE_ERROR": "Zmeny sa nepodarilo publikovať",
        "DISCARD_SUCCESS": "Zmeny boli zahodené",
        "DISCARD_ERROR": "Zmeny sa nepodarilo zahodiť"
      },
      "VERSION_HISTORY": {
        "MENU_ITEM": "História verzií",
        "TITLE": "História verzií",
        "BACK": "Späť na článok",
        "LOADING": "Načítavanie verzií...",
        "EMPTY": "Zatiaľ žiadne verzie. Úpravy tohto článku sa tu zobrazia.",
        "EMPTY_CONTENT": "Táto verzia nemá žiadny obsah.",
        "CURRENT_BADGE": "Aktuálna",
        "RESTORED_BADGE": "Obnovená",
        "AUTOMATED_USER": "Automatická aktualizácia",
        "RESTORE": "Obnoviť túto verziu",
        "RESTORE_DIALOG": {
          "TITLE": "Obnoviť túto verziu?",
          "DESCRIPTION": "Článok sa vráti k zneniu tejto verzie. Nič sa nestratí — aktuálny text zostane v histórii a publikovaný článok bude naďalej zobrazovať aktuálnu verziu, kým zmenu nepublikujete.",
          "CONFIRM": "Obnoviť"
        },
        "RESTORE_SUCCESS": "Verzia bola obnovená",
        "RESTORE_ERROR": "Nepodarilo sa obnoviť túto verziu",
        "FETCH_ERROR": "Nepodarilo sa načítať históriu verzií"
      },
      "EDIT_ARTICLE": {
        "MORE_PROPERTIES": "Ďalšie vlastnosti",
        "TRANSLATE": "Preložiť",
        "SOURCE": "Markdown",
        "UNCATEGORIZED": "Bez kategórie",
        "EDITOR_PLACEHOLDER": "Napíšte niečo...",
        "HTML_EMBED": {
          "TITLE": "Vložiť vlastné HTML",
          "DESCRIPTION": "Vložte čistý HTML kód, napríklad iframe, embed alebo widget. V publikovanom článku sa vykreslí tak, ako je.",
          "PLACEHOLDER": "<iframe src=\"https://...\"></iframe>",
          "INSERT": "Vložiť"
        },
        "PRIMARY_CATEGORY": "Hlavná kategória"
      },
      "ARTICLE_PROPERTIES": {
        "ARTICLE_PROPERTIES": "Vlastnosti článku",
        "SLUG": "Slug",
        "EDIT_SLUG": "Upraviť slug",
        "META_DESCRIPTION": "Meta popis",
        "META_DESCRIPTION_PLACEHOLDER": "Pridať meta popis",
        "META_TITLE": "Meta názov",
        "META_TITLE_PLACEHOLDER": "Pridať meta názov",
        "META_TAGS": "Meta značky",
        "META_TAGS_PLACEHOLDER": "Pridať meta značky",
        "SET_AS_HOMEPAGE": "Nastaviť ako domovskú stránku",
        "SET_AS_HOMEPAGE_HELP": "Zobraziť tento článok ako domovskú stránku centra pomoci pre tento jazyk. Pridajte {'{{NAV}}'} do obsahu pre zobrazenie vyhľadávania a kategórií.",
        "LANGUAGE_MUTATIONS": "Jazykové mutácie",
        "LANGUAGE_MUTATIONS_EMPTY": "Žiadne prepojené články",
        "ADD_MUTATION": "Pridať",
        "REMOVE_MUTATION": "Odobrať"
      },
      "LANGUAGE_MUTATIONS_DIALOG": {
        "TITLE": "Prepojiť jazykové mutácie",
        "SEARCH_PLACEHOLDER": "Hľadať články podľa názvu",
        "EMPTY": "Žiadne zodpovedajúce články",
        "CANCEL": "Zrušiť",
        "ADD_SELECTED": "Pridať vybrané",
        "SUCCESS": "Mutácie aktualizované",
        "ERROR": "Nepodarilo sa aktualizovať mutácie"
      },
      "TRANSLATE_DIALOG": {
        "TITLE": "Preložiť článok",
        "DESCRIPTION": "Vyberte jazyky, do ktorých chcete tento článok preložiť. Jazyky, ktoré sú už preložené, budú znovu preložené do Draftu na kontrolu.",
        "EMPTY": "Nie sú k dispozícii žiadne ďalšie jazyky.",
        "CONNECTED_BADGE": "Preložené",
        "CANCEL": "Zrušiť",
        "TRANSLATE": "Preložiť",
        "SUCCESS": "Preklad sa čoskoro spustí. Preložené články sa čoskoro zobrazia ako jazykové mutácie.",
        "ERROR": "Nepodarilo sa spustiť preklad"
      },
      "SLUG_DIALOG": {
        "TITLE": "Upraviť URL článku",
        "DESCRIPTION": "Zmeňte popisnú časť slugu tohto článku. Staré odkazy budú naďalej fungovať — automaticky presmerujú sem.",
        "INPUT_LABEL": "Slug",
        "PLACEHOLDER": "getting-started",
        "PREFIX_HINT": "Číselná predpona je trvalý identifikátor a nedá sa zmeniť.",
        "PREVIEW": "URL článku",
        "CANCEL": "Zrušiť",
        "SAVE": "Uložiť",
        "SUCCESS": "URL článku aktualizovaná",
        "ERROR": "Nepodarilo sa aktualizovať URL článku"
      },
      "API": {
        "ERROR": "Chyba pri ukladaní článku"
      }
    },
    "PORTAL_SWITCHER": {
      "NEW_PORTAL": "Nový portál",
      "PORTALS": "Portály",
      "CREATE_PORTAL": "Vytvárajte a spravujte viac portálov",
      "ARTICLES": "články",
      "DOMAIN": "doména",
      "PORTAL_NAME": "Názov portálu"
    },
    "CREATE_PORTAL_DIALOG": {
      "TITLE": "Vytvoriť nový portál",
      "DESCRIPTION": "Pomenujte svoj portál a vytvorte používateľsky prívetivý URL slug. Oboje môžete neskôr upraviť v nastaveniach.",
      "CONFIRM_BUTTON_LABEL": "Vytvoriť",
      "NAME": {
        "LABEL": "Názov",
        "PLACEHOLDER": "Používateľská príručka | JARABOT",
        "MESSAGE": "Zvoľte názov pre váš portál.",
        "ERROR": "Názov je povinný"
      },
      "SLUG": {
        "LABEL": "Slug",
        "PLACEHOLDER": "pouzivatelska-prirucka",
        "ERROR": "Slug je povinný",
        "FORMAT_ERROR": "Použite iba písmená, číslice a pomlčky, napríklad: user-guide"
      }
    },
    "DICTIONARY_PAGE": {
      "HEADER": {
        "TITLE": "Prekladový slovník",
        "DESCRIPTION": "Pojmy definované tu sa pridajú do promptu pre AI preklad, aby sa vždy prekladali rovnako. Kľúčový pojem je napísaný v jazyku {locale}."
      },
      "NEW_TERM": "Nový pojem",
      "EMPTY_STATE": {
        "TITLE": "Zatiaľ žiadne pojmy v slovníku",
        "SUBTITLE": "Pridajte pojem a jeho preklad pre každý jazyk. Pri preklade článku sa tieto pojmy vynútia, aby terminológia vášho produktu zostala konzistentná."
      },
      "LIST": {
        "TERM": "Pojem",
        "TRANSLATIONS": "Preklady",
        "ACTIONS": "Akcie"
      },
      "DICTIONARY_DIALOG": {
        "HEADER": {
          "CREATE": "Pridať pojem",
          "EDIT": "Upraviť pojem",
          "DESCRIPTION": "Pojem nižšie sa vynúti počas AI prekladu článkov centra pomoci.",
          "PORTAL": "Portál",
          "PRIMARY_LANGUAGE": "Hlavný jazyk"
        },
        "FORM": {
          "TERM": {
            "LABEL": "Pojem ({locale})",
            "PLACEHOLDER": "Schránka",
            "ERROR": "Pojem je povinný"
          },
          "DESCRIPTION": {
            "LABEL": "Kontext / poznámky (voliteľné)",
            "PLACEHOLDER": "Kedy a ako sa tento pojem používa, aby sa prekladateľ lepšie zorientoval."
          },
          "TRANSLATIONS": "Preklady",
          "TRANSLATION_PLACEHOLDER": "Nechajte prázdne, ak má AI prekladať voľne",
          "AUTO_TRANSLATE": {
            "BUTTON": "Preložiť všetko",
            "CONFIRM": "Preložiť do {count} jazykov pomocou AI?",
            "CONFIRM_BUTTON": "Preložiť",
            "CANCEL": "Zrušiť",
            "SUCCESS": "Preklady vygenerované — skontrolujte a uložte",
            "ERROR": "Automatický preklad zlyhal, skúste to znova"
          }
        },
        "BUTTONS": {
          "CREATE": "Pridať pojem",
          "EDIT": "Uložiť",
          "CANCEL": "Zrušiť"
        },
        "CREATE": {
          "API": {
            "SUCCESS_MESSAGE": "Pojem bol úspešne pridaný",
            "ERROR_MESSAGE": "Pojem sa nepodarilo pridať, skúste to znova"
          }
        },
        "EDIT": {
          "API": {
            "SUCCESS_MESSAGE": "Pojem bol úspešne aktualizovaný",
            "ERROR_MESSAGE": "Pojem sa nepodarilo aktualizovať, skúste to znova"
          }
        }
      },
      "DELETE": {
        "CONFIRM": {
          "TITLE": "Odstrániť pojem",
          "DESCRIPTION": "Naozaj chcete odstrániť tento pojem? Počas prekladu sa už nebude vynucovať.",
          "CONFIRM": "Odstrániť"
        },
        "API": {
          "SUCCESS_MESSAGE": "Pojem bol úspešne odstránený",
          "ERROR_MESSAGE": "Pojem sa nepodarilo odstrániť, skúste to znova"
        }
      }
    },
    "PORTAL_SETTINGS": {
      "FORM": {
        "AVATAR": {
          "LABEL": "Logo",
          "IMAGE_UPLOAD_ERROR": "Nepodarilo sa nahrať obrázok! Skúste to znova",
          "IMAGE_UPLOAD_SUCCESS": "Obrázok bol úspešne pridaný. Kliknite prosím na Uložiť zmeny pre uloženie loga",
          "IMAGE_DELETE_SUCCESS": "Logo bolo úspešne vymazané",
          "IMAGE_DELETE_ERROR": "Nepodarilo sa vymazať logo",
          "IMAGE_UPLOAD_SIZE_ERROR": "Veľkosť obrázka by mala byť menšia ako {size} MB"
        },
        "HERO_IMAGE": {
          "LABEL": "Obrázok na pozadí",
          "HELP_TEXT": "Voliteľný obrázok na celú šírku zobrazený za vycentrovaným vyhľadávacím poľom na domovskej stránke centra pomoci.",
          "IMAGE_UPLOAD_ERROR": "Nepodarilo sa nahrať obrázok! Skúste to znova",
          "IMAGE_UPLOAD_SUCCESS": "Obrázok bol úspešne pridaný. Kliknite prosím na Uložiť zmeny pre uloženie obrázka na pozadí",
          "IMAGE_DELETE_SUCCESS": "Obrázok na pozadí bol úspešne odstránený",
          "IMAGE_DELETE_ERROR": "Nepodarilo sa odstrániť obrázok na pozadí",
          "IMAGE_UPLOAD_SIZE_ERROR": "Veľkosť obrázka by mala byť menšia ako {size} MB"
        },
        "HOMEPAGE_ARTICLES": {
          "LABEL": "Články domovskej stránky",
          "EMPTY": "Žiadny článok nie je nastavený ako domovská stránka. Nastavte ho vo vlastnostiach článku.",
          "HELP_TEXT": "Článok zobrazený ako domovská stránka pre každý jazyk. Kliknutím ho otvoríte, alebo odstráňte pre obnovenie predvolenej domovskej stránky.",
          "REMOVE": "Odstrániť",
          "REMOVE_SUCCESS": "Článok domovskej stránky odstránený",
          "REMOVE_ERROR": "Nepodarilo sa odstrániť článok domovskej stránky"
        },
        "NAME": {
          "LABEL": "Názov",
          "PLACEHOLDER": "Názov portálu",
          "ERROR": "Názov je povinný"
        },
        "HEADER_TEXT": {
          "LABEL": "Text hlavičky",
          "PLACEHOLDER": "Text hlavičky portálu"
        },
        "PAGE_TITLE": {
          "LABEL": "Názov stránky",
          "PLACEHOLDER": "Názov stránky portálu"
        },
        "HOME_PAGE_LINK": {
          "LABEL": "Odkaz na domovskú stránku",
          "PLACEHOLDER": "Odkaz na domovskú stránku portálu",
          "ERROR": "Neplatná URL. Odkaz na domovskú stránku musí začínať 'http://' alebo 'https://'."
        },
        "SLUG": {
          "LABEL": "Slug",
          "PLACEHOLDER": "Slug portálu"
        },
        "LIVE_CHAT_WIDGET": {
          "LABEL": "Widget živého chatu",
          "PLACEHOLDER": "Vyberte widget živého chatu",
          "HELP_TEXT": "Vyberte widget živého chatu, ktorý sa zobrazí vo vašom centre pomoci"
        },
        "LINK_TARGET": {
          "LABEL": "Cieľ odkazu",
          "HELP_TEXT": "Vyberte, či sa odkazy v článkoch otvárajú v aktuálnom okne alebo v novom.",
          "OPTIONS": {
            "CURRENT_WINDOW": "Aktuálne okno",
            "NEW_WINDOW": "Nové okno"
          }
        },
        "PUBLIC_ACCESS": {
          "LABEL": "Verejne dostupné",
          "HELP_TEXT": "Ak je nastavené ako verejné, portál si môže zobraziť ktokoľvek s odkazom na portál",
          "OPTIONS": {
            "PUBLIC": "Áno",
            "PRIVATE": "Nie"
          }
        },
        "DEFAULT_IMAGE_SIZE": {
          "LABEL": "Predvolená veľkosť obrázka",
          "HELP_TEXT": "Veľkosť, ktorá sa použije pri každom obrázku vloženom do článku. Zvoľte Originálna, ak sa majú obrázky vkladať v pôvodnej veľkosti a chcete veľkosť voliť pri každom zvlášť."
        },
        "BRAND_COLOR": {
          "LABEL": "Farba značky"
        },
        "CUSTOM_HTML": {
          "LABEL": "Vlastné HTML",
          "PLACEHOLDER": "<!-- Sem vložte svoj analytický alebo meriaci kód -->",
          "HELP_TEXT": "Vloží sa na začiatok značky <body> na každej stránke centra pomoci. Použite ho pre Google Analytics, Google Tag Manager alebo akýkoľvek iný meriaci kód. Kód sa vykreslí presne tak, ako ho zadáte, a nijako sa nekontroluje."
        },
        "SAVE_CHANGES": "Uložiť zmeny"
      },
      "CONFIGURATION_FORM": {
        "CUSTOM_DOMAIN": {
          "HEADER": "Vlastná doména",
          "LABEL": "Vlastná doména:",
          "DESCRIPTION": "Svoj portál môžete hostovať na vlastnej doméne. Ak je napríklad vaša webová stránka vasa-domena.com a chcete, aby bol váš portál dostupný na docs.vasa-domena.com, jednoducho to zadajte do tohto poľa.",
          "PLACEHOLDER": "Vlastná doména portálu",
          "EDIT_BUTTON": "Upraviť vlastnú doménu",
          "ADD_BUTTON": "Pridať vlastnú doménu",
          "DIALOG": {
            "ADD_HEADER": "Pridať vlastnú doménu",
            "EDIT_HEADER": "Upraviť vlastnú doménu",
            "ADD_CONFIRM_BUTTON_LABEL": "Pridať doménu",
            "EDIT_CONFIRM_BUTTON_LABEL": "Aktualizovať doménu",
            "LABEL": "Vlastná doména",
            "PLACEHOLDER": "Vlastná doména portálu",
            "ERROR": "Vlastná doména je povinná"
          },
          "DNS_CONFIGURATION_DIALOG": {
            "HEADER": "Konfigurácia DNS",
            "DESCRIPTION": "Prihláste sa k účtu u svojho poskytovateľa DNS a pridajte záznam CNAME pre subdoménu smerujúcu na chat.jarabot.com",
            "HELP_TEXT": "Keď to bude hotové, môžete kontaktovať našu podporu a požiadať o automaticky generovaný SSL certifikát.",
            "CONFIRM_BUTTON_LABEL": "Rozumiem!"
          }
        },
        "DELETE_PORTAL": {
          "BUTTON": "Vymazať {portalName}",
          "HEADER": "Vymazať portál",
          "DESCRIPTION": "Trvalo vymazať tento portál. Táto akcia je nevratná",
          "DIALOG": {
            "HEADER": "Naozaj chcete vymazať {portalName}?",
            "DESCRIPTION": "Toto je trvalá akcia, ktorú nie je možné vrátiť späť.",
            "CONFIRM_BUTTON_LABEL": "Vymazať"
          }
        },
        "EDIT_CONFIGURATION": "Upraviť konfiguráciu"
      },
      "API": {
        "CREATE_PORTAL": {
          "SUCCESS_MESSAGE": "Portál bol úspešne vytvorený",
          "ERROR_MESSAGE": "Nepodarilo sa vytvoriť portál"
        },
        "UPDATE_PORTAL": {
          "SUCCESS_MESSAGE": "Portál bol úspešne aktualizovaný",
          "ERROR_MESSAGE": "Nepodarilo sa aktualizovať portál"
        }
      }
    },
    "ATTACHMENTS": {
      "TITLE": "Prílohy",
      "DRAFT_BADGE": "Koncept",
      "ADD_BUTTON": "Pridať súbor",
      "DROP_HERE": "Presuňte súbory sem",
      "COPY_LINK": "Kopírovať odkaz",
      "LINK_COPIED": "Odkaz skopírovaný do schránky",
      "COPY_FAILED": "Nepodarilo sa skopírovať odkaz",
      "DELETE": "Vymazať",
      "CANCEL": "Zrušiť",
      "QUEUED": "Vo fronte",
      "UPLOADING": "Nahráva sa",
      "UPLOAD_FAILED": "Nahrávanie súboru zlyhalo",
      "FILE_TOO_LARGE": "Súbor prekračuje limit 40 MB"
    }
  }
}
